import React, { useState } from 'react';
import { Button, Input, Card, Logo, Select } from '../components/components';
import { PageContainer, Footer } from '../layout/layouts';
import { theme } from '../styles/theme';

export const Register: React.FC = () => {
  const [academyName, setAcademyName] = useState('');
  const [email, setEmail] = useState('');
  const [subdomain, setSubdomain] = useState('');
  const [plan, setPlan] = useState('GROWTH_SAAS');

  const handleRegister = (e: React.FormEvent) => {
    e.preventDefault();
    console.log({ academyName, email, subdomain, plan });
  };

  return (
    <PageContainer>
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', flex: 1, padding: `${theme.spacing.xxl} 0` }}>
        <Logo size="lg" style={{ marginBottom: theme.spacing.xl }} />
        
        <Card style={{ width: '100%', maxWidth: '460px', padding: theme.spacing.lg }} hoverable={false}>
          <h2 style={{ margin: '0 0 8px 0', fontSize: theme.typography.fontSize.xl, color: theme.colors.textPrimary, textAlign: 'center' }}>
            Register Your Coaching Center
          </h2>
          <p style={{ margin: `0 0 ${theme.spacing.lg} 0`, fontSize: theme.typography.fontSize.sm, color: theme.colors.textSecondary, textAlign: 'center' }}>
            Initialize your tenant and white-labeled student portal in under 2 minutes.
          </p>

          <form onSubmit={handleRegister} style={{ display: 'flex', flexDirection: 'column', gap: theme.spacing.md }}>
            <Input
              type="text"
              label="Academy / Institute Name"
              placeholder="ABC Academy Pvt Ltd"
              value={academyName}
              onChange={(e) => setAcademyName(e.target.value)}
              required
            />
            <Input
              type="email"
              label="Owner Email Address"
              placeholder="founder@abcacademy.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
            <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
              <label style={{ fontSize: theme.typography.fontSize.xs, fontWeight: theme.typography.fontWeight.semibold, color: theme.colors.textSecondary }}>Desired Subdomain</label>
              <div style={{ display: 'flex', alignItems: 'center', border: `1px solid ${theme.colors.border}`, borderRadius: theme.radius.md, overflow: 'hidden', height: '48px' }}>
                <input
                  type="text"
                  placeholder="abc-academy"
                  style={{ flex: 1, border: 'none', outline: 'none', padding: '0 12px', fontSize: theme.typography.fontSize.sm }}
                  value={subdomain}
                  onChange={(e) => setSubdomain(e.target.value)}
                  required
                />
                <span style={{ backgroundColor: theme.colors.surfaceMuted, height: '100%', display: 'flex', alignItems: 'center', padding: '0 12px', borderLeft: `1px solid ${theme.colors.border}`, fontSize: theme.typography.fontSize.xs, color: theme.colors.textSecondary }}>
                  .millish.shop
                </span>
              </div>
            </div>

            <Select
              label="Select SaaS Tier Plan"
              value={plan}
              onChange={(e) => setPlan(e.target.value)}
              options={[
                { value: 'GROWTH_SAAS', label: 'Growth Plan (Up to 100 students) - ₹4,999/mo' },
                { value: 'ENTERPRISE_SLS', label: 'Scale Plan (Unlimited students + DRM) - ₹9,999/mo' },
                { value: 'SUPER_ADMIN_GLOBAL', label: 'Global Dedicated SLA Instance - Custom Quote' }
              ]}
            />

            <Button type="submit" fullWidth style={{ marginTop: theme.spacing.sm }}>
              Initialize Sandbox Workplace
            </Button>
          </form>

          <div style={{ textAlign: 'center', marginTop: theme.spacing.lg, fontSize: theme.typography.fontSize.xs, color: theme.colors.textSecondary }}>
            Already registered? <a href="/login" style={{ color: theme.colors.primary, textDecoration: 'none', fontWeight: theme.typography.fontWeight.semibold }}>Sign In Here</a>
          </div>
        </Card>
      </div>
      <Footer />
    </PageContainer>
  );
};

export default Register;
